<div class="wrapper__contentComponent--expediente container my-5">
  <!-- Entidad -->
  <h3 class="h4-tipografia-govco text-center">
    <span data-bs-toggle="collapse" aria-expanded="false">
      <img
        [src]="
          entity!.Logo ? entity!.Logo : '../../../../assets/img/H-DIMAR.png'
        "
        alt="{{ entity!.Entidad }} logo"
        class="logo-img" />
      {{ entity!.Entidad }}
    </span>
  </h3>

  <div class="d-flex flex-column justify-content-center mt-3">
    <h5 class="text-center">Seleccionar Proceso</h5>
    <select
      #processSelect
      class="form-select w-50 mx-auto"
      (change)="onProcessSelected($event)">
      <option [ngValue]="null" disabled selected>Seleccione un proceso</option>
      <option *ngFor="let process of processes" [value]="process.Id">
        {{ process.ProcessName }}
      </option>
    </select>
  </div>
  <!-- Nota -->
  <div>
    <p style="text-align: center; font-size: 8px">
      <strong>Nota:</strong>Todos los dominios creados en esta funcionalidad
      seran idexados.
    </p>
  </div>
  <!-- Tabla  -->
  <div
    class="table-container mt-5 text-center"
    *ngIf="documentalInfoRegistersFiltered.length > 0; else noData">
    <table class="table table-striped table-bordered">
      <thead class="custom-header">
        <tr>
          <th>Archivo</th>
          <th>Creado Por</th>
          <th>Fecha Creación</th>
          <th>Dataset</th>
          <th>Estado</th>
          <th>Acciones</th>
        </tr>
      </thead>
      <tbody>
        <tr
          *ngFor="let doc of documentalInfoRegistersFiltered"
          class="hover-effect">
          <td>{{ doc.FileName }}</td>
          <td>{{ doc.CreatedBy }}</td>
          <td>{{ doc.CreatedAt | date: 'yyyy-MM-dd' }}</td>
          <td>{{ doc.DatasetId }}</td>
          <td>{{ doc.State === 0 ? 'Creado' : 'Editado' }}</td>
          <td>
            <button
              class="btn btn-sm btn-outline-primary me-2"
              (click)="updateDocInfo(doc)">
              Editar
            </button>
            <button
              class="btn btn-sm btn-outline-primary"
              (click)="deleteDocumentalInfoRegister(doc)">
              Eliminar
            </button>
          </td>
        </tr>
      </tbody>
    </table>
    <div class="d-flex justify-content-between align-items-center mt-3">
      <div>
        Mostrando {{ (currentPage - 1) * itemsPerPage + 1 }} -
        {{ getMinValue(currentPage * itemsPerPage, totalItems) }} de
        {{ totalItems }} registros
      </div>

      <nav>
        <ul class="pagination">
          <li class="page-item" [class.disabled]="currentPage === 1">
            <a class="page-link" (click)="pageChanged(currentPage - 1)"
              >&laquo; Anterior</a
            >
          </li>

          <li
            class="page-item"
            *ngFor="let page of getPages()"
            [class.active]="page === currentPage">
            <a class="page-link" (click)="pageChanged(page)">{{ page }}</a>
          </li>

          <li
            class="page-item"
            [class.disabled]="currentPage * itemsPerPage >= totalItems">
            <a class="page-link" (click)="pageChanged(currentPage + 1)"
              >Siguiente &raquo;</a
            >
          </li>
        </ul>
      </nav>
    </div>
  </div>
  <!-- Plantilla para mostrar mensaje si no hay datos -->
  <ng-template #noData>
    <div class="no-data-container text-center mt-5">
      <p>No hay datos disponibles</p>
    </div>
  </ng-template>

  <!-- Registrar nuevo documento -->
  <div
    class="upload-container mt-5"
    [class.dragging]="isDragging"
    (dragover)="onDragOver($event)"
    (dragleave)="onDragLeave($event)"
    (drop)="onDrop($event)">
    <h5>
      {{
        selectedProcess
          ? 'Cargar nuevo archivo para ' + selectedProcess.ProcessName
          : 'Selecciona un proceso primero por favor'
      }}
    </h5>
    <div class="upload-box">
      <label for="fileUpload">
        <span class="upload-icon">⬆</span>
        <br />
        Arrastre el archivo .pdf
      </label>
      <input
        id="fileUpload"
        type="file"
        class="file-input"
        accept=".pdf"
        [disabled]="selectedProcess === null"
        (change)="onFileSelected($event)" />
    </div>
  </div>
</div>
<div *ngIf="modalUpdateDocInfo">
  <app-modal-editar-info-docs-ent
    [docuemtalInfoRegister]="documentalInfoRegister">
  </app-modal-editar-info-docs-ent>
</div>
